import React from 'react';
import Spinner from 'react-spinner';

import NationalReportsList from '../../NationalReports/NationalReportsList';
import CountryProfileReportListItem from './ItemReportListItem';

class CountryProfileReportList extends NationalReportsList {
  componentWillUpdate() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.reports !== this.props.reports) {
      this.onRequestComplete(nextProps.reports, null);
    }
  }

  componentDidMount() {
    this.onRequestComplete(this.props.reports, null);
  }

  renderListItems() {
    const reports = this.state.reports;

    if (!reports || reports.length === 0) return null;

    return reports.map((item, index) => (
      <CountryProfileReportListItem key={ index } data={ item } />
    ));
  }

  render() {
    if (this.props.isLoading) return <Spinner className="national-contacts__spinner" />;

    return (
      <table className="table table-responsive country-profile__reports">
        <tbody>
          <tr>
            <th>Reporting Year</th>
            <th>Available in</th>
          </tr>

          { this.renderListItems() }
        </tbody>
      </table>
    );
  }
}

export default CountryProfileReportList;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/Menu/ItemReportList.js